import React from 'react';
import { Button } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import eduidMessages from '@fhnw/messages/eduid';

/**
 * Branded button that starts the SWITCH edu-ID OIDC login (#961).
 * @function EduIDLoginButton
 * @param {Object} props Component props.
 * @param {Function} props.onClick Click handler, starts the OIDC redirect.
 * @returns {JSX.Element} Markup of the edu-ID login button.
 */
function EduIDLoginButton({ onClick }) {
  return (
    <Button
      id="eduid-login"
      primary
      className="btn btn--primary"
      onClick={onClick}
    >
      <FormattedMessage {...eduidMessages.eduidLogin} />
    </Button>
  );
}

export default EduIDLoginButton;
